import type { PeriodOption } from '@repo/shared-dashboard';
import { fetcher } from '../../lib/api-fetcher';
import type { StaffDashboardMetrics } from './types';

const BASE = '/staff/v1/reporting/dashboard';

export function getStaffDashboardMetrics(period: PeriodOption = 'month'): Promise<StaffDashboardMetrics> {
  const params = new URLSearchParams({ period });
  return fetcher.get<StaffDashboardMetrics>(`${BASE}?${params.toString()}`);
}
